import React from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { Helmet } from 'react-helmet-async';
export const OpenGraphGeneralPageData = ({ data, route, optionalFields = [] }) => {
    var _a, _b, _c, _d;
    const { selectedChannel } = React.useContext(ChannelContext);
    if (!data || data.__typename === 'Error')
        return null;
    const metaDescriptionTag = (_b = (_a = data.head) === null || _a === void 0 ? void 0 : _a.metaTags) === null || _b === void 0 ? void 0 : _b.filter((tag) => tag.name === 'description')[0];
    const overrides = optionalFields.map((tag) => tag.property);
    const title = ((_c = data.head) === null || _c === void 0 ? void 0 : _c.title) ||
        (data.__typename !== 'StartPage' && data.mainHeader) ||
        data.name;
    // If these are updated, please also update the docs (OpenGraph.mdx)
    const defaultTags = [
        {
            property: 'og:url',
            content: (route === null || route === void 0 ? void 0 : route.canonicalPath) && `${selectedChannel.url}${route.canonicalPath}`
        },
        { property: 'og:title', content: title },
        {
            property: 'og:description',
            content: metaDescriptionTag === null || metaDescriptionTag === void 0 ? void 0 : metaDescriptionTag.content
        },
        {
            property: 'og:image',
            content: ((_d = data.images) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                (data.__typename !== 'Product'
                    ? data.images[data.images.length - 1].url
                    : data.images[0].url)
        }
    ].filter((tag) => !overrides.includes(tag.property));
    return (React.createElement(Helmet, null,
        defaultTags.map((tag) => tag.content && (React.createElement("meta", { key: `og-tag-${tag.property}`, property: tag.property, content: tag.content }))),
        optionalFields.map((tag) => (React.createElement("meta", { key: `og-tag-${tag.property}`, property: tag.property, content: tag.content })))));
};
//# sourceMappingURL=OpenGraphGeneralPageData.js.map